import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  country: {
    id: 'donater.select_country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'donater.select_state',
    defaultMessage: 'State',
  },
  stateRequired: {
    id: 'donater.select_state_required',
    defaultMessage: 'State is required',
  },
  countryRequired: {
    id: 'donater.select_country_required',
    defaultMessage: 'Country is required',
  },
})
